import QuestionRenderer from "./QuestionRenderer";

const PrincipleRenderer = ({
  sections,
  formData,
  errors,
  setErrors,
  onChange,
  isEditable
}) => {

  const allQuestions = [

    ...(sections?.essential || []),

    ...(sections?.leadership || [])

  ];

  return (

    <>

      {allQuestions.map((question) => (

        <QuestionRenderer
          key={question.question_id}
          question={question}
          value={
            formData[
              question.question_code
            ]
          }
          formData={formData}
          errors={errors}
          setErrors={setErrors}
          onChange={onChange}
          isEditable={isEditable}
        />

      ))}

    </>

  );
};

export default PrincipleRenderer;